import React, { createContext, useContext, useState, useEffect } from "react";
import { useIp } from "./IpContext";

const DisplayConfigContext = createContext(null);

export function DisplayConfigProvider({ children }) {
  const [displayConfigs, setDisplayConfigs] = useState(null);
  const { ipAddress, port } = useIp();

  useEffect(() => {
    if (!ipAddress) return;
    fetch(`http://${ipAddress}:${port}/api/display-configs`)
      .then((r) => r.json())
      .then(setDisplayConfigs)
      .catch((err) => console.error("Failed to load display configs:", err));
  }, [ipAddress, port]);

  const saveDisplayConfigs = async (configs) => {
    await fetch(`http://${ipAddress}:${port}/api/display-configs`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ configs }),
    });
    setDisplayConfigs(configs);
  };

  return (
    <DisplayConfigContext.Provider value={{ displayConfigs, saveDisplayConfigs }}>
      {children}
    </DisplayConfigContext.Provider>
  );
}

export function useDisplayConfig() {
  return useContext(DisplayConfigContext);
}
